import { create } from 'zustand';

import { GameSlice, createGameSlice } from './slices/gameSlice';
import { PlayerSlice, createPlayerSlice } from './slices/playerSlice';
import { ModelSlice, createModelSlice } from './slices/modelSlice';
import { TimerSlice, createTimerSlice } from './slices/timerSlice';
import { ScoreSlice, createScoreSlice } from './slices/scoreSlice';

export interface GameState extends 
  GameSlice, 
  PlayerSlice, 
  ModelSlice, 
  TimerSlice, 
  ScoreSlice {}

const useGameStore = create<GameState>((set, get, store) => ({
  ...createGameSlice(set, get, store),
  ...createPlayerSlice(set, get, store),
  ...createModelSlice(set, get, store),
  ...createTimerSlice(set, get, store),
  ...createScoreSlice(set, get, store),
}));

export default useGameStore;